
import { useDispatch, useSelector } from "react-redux";
import "../assets/css/storage.css"
import SearchByCodePopUp from "./popups/SearchByCodePopup";
import Overlay from "./overlay";
import SearchByNamePopUp from "./popups/SearchByNamePopup";
import DeleteProductPopUp from "./popups/DeleteProductPopup";
import AddProductPopUp from "./popups/AddProductPopup";
import EditProductPricePopUp from "./popups/EditProductPrice(SINGLE)";
import EditCategoryPricePopUp from "./popups/EditCategoryPricePopup";
import { JSFunctions } from "../App";
import { useEffect, useState } from "react";
import Toasts from "../assets/toasts/toasts";
import { Navigate, useNavigate } from "react-router-dom";

function Storage(){
    let icons = {
        searchWhite: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <path d="M27.5 15.3332C27.5 22.0526 22.0528 27.4998 15.3334 27.4998C8.61389 27.4998 3.16669 22.0526 3.16669 15.3332C3.16669 8.61371 8.61389 3.1665 15.3334 3.1665C22.0528 3.1665 27.5 8.61371 27.5 15.3332Z" fill="white" stroke="white"/>
        <path d="M28.4 28.8332C28.2856 28.8332 28.1749 28.7877 28.1002 28.713L25.6202 26.233C25.4599 26.0727 25.45 25.8002 25.6234 25.617C25.7842 25.4595 26.0548 25.451 26.2369 25.6239L28.7131 28.1001C28.8714 28.2585 28.883 28.5264 28.7161 28.7095C28.6218 28.7925 28.5071 28.8332 28.4 28.8332Z" fill="white" stroke="white"/>
      </svg>,
      searchPurple: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path d="M28 15.3332C28 22.0526 22.5528 27.4998 15.8333 27.4998C9.11387 27.4998 3.66666 22.0526 3.66666 15.3332C3.66666 8.61371 9.11387 3.1665 15.8333 3.1665C22.5528 3.1665 28 8.61371 28 15.3332Z" fill="#405189" stroke="#405189"/>
      <path d="M28.9 28.8332C28.7856 28.8332 28.6749 28.7877 28.6002 28.713L26.1202 26.233C25.9599 26.0727 25.95 25.8002 26.1234 25.617C26.2843 25.4595 26.5548 25.451 26.7369 25.6239L29.2131 28.1001C29.3715 28.2585 29.3831 28.5264 29.2161 28.7095C29.1218 28.7925 29.0072 28.8332 28.9 28.8332Z" fill="#405189" stroke="#405189"/>
    </svg>,
      hideControlBtns: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
      <path d="M28.86 12.2401C28.4733 11.6267 28.06 11.0534 27.6333 10.5201C27.14 9.8934 26.2067 9.84007 25.6467 10.4001L21.6467 14.4001C21.94 15.2801 21.9933 16.2934 21.7267 17.3467C21.26 19.2267 19.74 20.7467 17.86 21.2134C16.8067 21.4801 15.7933 21.4267 14.9133 21.1334C14.9133 21.1334 13.0067 23.0401 11.6333 24.4134C10.9667 25.0801 11.18 26.2534 12.0733 26.6001C13.5 27.1467 14.98 27.4267 16.5 27.4267C18.8733 27.4267 21.18 26.7334 23.2867 25.4401C25.4333 24.1067 27.3667 22.1467 28.9267 19.6534C30.1933 17.6401 30.1267 14.2534 28.86 12.2401Z" fill="#405189"/>
      <path d="M19.1933 13.3065L13.8067 18.6932C13.1267 17.9999 12.6867 17.0399 12.6867 15.9999C12.6867 13.9065 14.3933 12.1865 16.5 12.1865C17.54 12.1865 18.5 12.6265 19.1933 13.3065Z" fill="#405189"/>
      <path d="M24.8333 7.66658L20.3133 12.1866C19.34 11.1999 17.9933 10.6132 16.5 10.6132C13.5133 10.6132 11.1133 13.0266 11.1133 15.9999C11.1133 17.4932 11.7133 18.8399 12.6867 19.8132L8.17999 24.3332H8.16666C6.68666 23.1332 5.32666 21.5999 4.16666 19.7866C2.83332 17.6932 2.83332 14.2932 4.16666 12.1999C5.71332 9.77324 7.60666 7.86658 9.71332 6.55991C11.82 5.27991 14.1267 4.57324 16.5 4.57324C19.4733 4.57324 22.3533 5.66658 24.8333 7.66658Z" fill="#405189"/>
      <path d="M20.3133 16.0001C20.3133 18.0934 18.6067 19.8134 16.5 19.8134C16.42 19.8134 16.3533 19.8134 16.2733 19.7868L20.2867 15.7734C20.3133 15.8534 20.3133 15.9201 20.3133 16.0001Z" fill="#405189"/>
      <path d="M29.5267 2.97334C29.1267 2.57334 28.4733 2.57334 28.0733 2.97334L3.47334 27.5867C3.07334 27.9867 3.07334 28.64 3.47334 29.04C3.67334 29.2267 3.92667 29.3333 4.19334 29.3333C4.46001 29.3333 4.71334 29.2267 4.91334 29.0267L29.5267 4.41334C29.94 4.01334 29.94 3.37334 29.5267 2.97334Z" fill="#405189"/>
    </svg>,
    delete: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
    <path d="M29.32 10.4118V10.4132V21.5865C29.32 23.9137 28.6283 25.7112 27.4131 26.9263C26.198 28.1414 24.4006 28.8332 22.0734 28.8332H10.9134C8.58613 28.8332 6.78886 28.1414 5.5738 26.9248C4.35866 25.7082 3.66669 23.9074 3.66669 21.5732V10.4132C3.66669 8.08594 4.35845 6.28852 5.57357 5.07339C6.7887 3.85827 8.58612 3.1665 10.9134 3.1665H22.0867C24.414 3.1665 26.2112 3.85831 27.4246 5.07317C28.6378 6.28793 29.3264 8.08488 29.32 10.4118ZM21.3336 20.8334C21.9155 20.2515 21.9155 19.2949 21.3336 18.713L18.6205 15.9998L21.3336 13.2867C21.9155 12.7048 21.9155 11.7482 21.3336 11.1663C20.7516 10.5844 19.7951 10.5844 19.2131 11.1663L16.5 13.8794L13.7869 11.1663C13.205 10.5844 12.2484 10.5844 11.6665 11.1663C11.0845 11.7482 11.0845 12.7048 11.6665 13.2867L14.3796 15.9998L11.6665 18.713C11.0845 19.2949 11.0845 20.2515 11.6665 20.8334C11.9652 21.1321 12.3479 21.2732 12.7267 21.2732C13.1055 21.2732 13.4882 21.1321 13.7869 20.8334L16.5 18.1203L19.2131 20.8334C19.5118 21.1321 19.8946 21.2732 20.2734 21.2732C20.6521 21.2732 21.0349 21.1321 21.3336 20.8334Z" fill="#405189" stroke="#405189"/>
  </svg>,
    add: <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
    <path d="M29.32 10.4118V10.4132V21.5865C29.32 23.9137 28.6282 25.7112 27.4131 26.9263C26.198 28.1414 24.4006 28.8332 22.0733 28.8332H10.9133C8.58612 28.8332 6.78884 28.1414 5.57378 26.9248C4.35865 25.7082 3.66667 23.9074 3.66667 21.5732V10.4132C3.66667 8.08594 4.35843 6.28852 5.57356 5.07339C6.78868 3.85827 8.58611 3.1665 10.9133 3.1665H22.0867C24.414 3.1665 26.2112 3.85831 27.4246 5.07317C28.6378 6.28793 29.3264 8.08488 29.32 10.4118ZM18 21.3332V17.4998H21.8333C22.6561 17.4998 23.3333 16.8226 23.3333 15.9998C23.3333 15.177 22.6561 14.4998 21.8333 14.4998H18V10.6665C18 9.84369 17.3228 9.1665 16.5 9.1665C15.6772 9.1665 15 9.8437 15 10.6665V14.4998H11.1667C10.3439 14.4998 9.66667 15.177 9.66667 15.9998C9.66667 16.8226 10.3439 17.4998 11.1667 17.4998H15V21.3332C15 22.156 15.6772 22.8332 16.5 22.8332C17.3228 22.8332 18 22.156 18 21.3332Z" fill="#405189" stroke="#405189"/>
  </svg>,
    edit: <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M28.82 10.4118V10.4132V21.5865C28.82 23.9137 28.1282 25.7112 26.9131 26.9263C25.698 28.1414 23.9006 28.8332 21.5733 28.8332H10.4133C8.0861 28.8332 6.28883 28.1414 5.07376 26.9248C3.85863 25.7082 3.16666 23.9074 3.16666 21.5732V10.4132C3.16666 8.08594 3.85842 6.28852 5.07354 5.07339C6.28867 3.85827 8.08609 3.1665 10.4133 3.1665H21.5867C23.914 3.1665 25.7112 3.85831 26.9245 5.07317C28.1378 6.28793 28.8264 8.08488 28.82 10.4118ZM13.0171 24.6815L13.0171 24.6815L13.0208 24.681C13.3567 24.6306 13.7258 24.4945 14.0549 24.3272C14.3841 24.1599 14.7117 23.9417 14.9529 23.7007C14.9531 23.7005 14.9533 23.7003 14.9535 23.7001L20.9257 17.7679L21.5018 17.1956L20.7314 16.9388C20.4788 16.8546 20.2216 16.7451 19.9183 16.6133C19.626 16.4671 19.3545 16.3308 19.1106 16.1844L19.0991 16.1775L19.0873 16.1713C18.8937 16.0688 18.704 15.9395 18.5 15.7865L18.4924 15.7808L18.4846 15.7754C18.3285 15.6673 18.1432 15.5194 17.939 15.3561L17.8984 15.3236C17.8973 15.3225 17.896 15.3213 17.8948 15.3201C17.8872 15.3128 17.8782 15.304 17.8676 15.2935L17.8069 15.2329L17.7915 15.2176L17.7749 15.2037C17.4607 14.9397 17.0958 14.5871 16.7841 14.2131L16.7696 14.1957L16.7574 14.1835C16.7569 14.1829 16.7562 14.1821 16.7553 14.1811C16.7507 14.1757 16.7436 14.1671 16.7341 14.155C16.715 14.1309 16.6899 14.0974 16.6602 14.0559L16.6447 14.0342L16.627 14.0143C16.5328 13.9083 16.3761 13.7153 16.2464 13.5149L16.237 13.5003L16.2267 13.4865C16.1161 13.3391 15.9802 13.1413 15.8576 12.933L15.8576 12.933L15.8554 12.9293C15.7085 12.6844 15.5705 12.4096 15.4397 12.1349C15.3015 11.833 15.2004 11.5682 15.0939 11.2885L14.819 10.567L14.2731 11.113L8.32923 17.0568C8.0793 17.2994 7.86016 17.6252 7.69378 17.9542C7.52649 18.2851 7.39504 18.6539 7.34526 18.9941L7.34497 18.9961L6.87892 22.2719C6.87881 22.2726 6.8787 22.2733 6.87859 22.2741C6.75291 23.1107 6.97045 23.9174 7.53977 24.4867C8.00727 24.9542 8.64815 25.1798 9.30666 25.1798C9.45465 25.1798 9.59817 25.1639 9.71189 25.1512L9.72187 25.1501L9.72949 25.1493L9.73709 25.1482L13.0171 24.6815ZM22.2869 16.3801L22.2888 16.3781L23.5135 15.1401C23.5139 15.1397 23.5142 15.1394 23.5145 15.1391C24.5761 14.0772 25.1641 13.0004 25.1799 11.8601H25.18V11.8532C25.18 10.6589 24.5931 9.56585 23.5269 8.49962C22.4833 7.45602 21.3845 6.8541 20.2175 6.84818C19.0492 6.84225 17.9385 7.43421 16.8731 8.49962L15.6423 9.73043C15.383 9.96847 15.3166 10.3278 15.3976 10.6247L15.3976 10.6247L15.3992 10.6305C16.218 13.4962 18.4985 15.7818 21.3612 16.6078C21.4416 16.6361 21.5115 16.6414 21.5352 16.6433L21.5366 16.6434C21.5808 16.6468 21.6235 16.6465 21.64 16.6465C21.8703 16.6465 22.107 16.56 22.2869 16.3801Z" fill="#405189" stroke="#405189"/>
  </svg>
    }
    const Toast = new Toasts();
    const state = useSelector(state => state);
    const [overlay, setOverlayState] = useState(false);
    const [products, setTableProducts] = useState([]);
    const [controlBtns,setControlBtns] = useState(true);
    let navigate = useNavigate()

    let searchByCodeWidgetState =  state.searchByCodeWidgetState;
    let searchByNameWidgetState =  state.searchByNameWidgetState;
    let deleteProductWidgetState =  state.deleteProductWidgetState;
    let addProductWidgetState =  state.addProductWidgetState;
    let editProductPriceWidgetState =  state.editProductPriceWidgetState;
    let editCategoryPriceWidgetState =  state.editCategoryPriceWidgetState;

    const dispatch = useDispatch();
    let handleBtns = (state) => {
      dispatch({ type: "", payload: { [state]: true } });
    }
    async function loadData(){
      let functions = new JSFunctions();
          setOverlayState(true);
          let products = await functions.searchByName("");
          setOverlayState(false);
          if (!products) {
            Toast.error("لم يتم العثور علي منتجات");
          }else {
            setTableProducts(products)
            console.log(products)
        }
    }
    useEffect(()=>{
      loadData();
    },[])
    return <>
    <div className="storage">
        <div className="btns">
            <div className="btn" onClick={()=>handleBtns("searchByCodeWidgetState")}>
            {icons.searchWhite}
            بحث بالكود
            </div>
            <div className="btn" onClick={()=>handleBtns("searchByNameWidgetState")}>
            {icons.searchPurple}
            بحث بالإسم
            </div>
            <div className="btn" onClick={()=>setControlBtns(!controlBtns)}>
            {icons.hideControlBtns}
            إخفاء عناصر التحكم
            </div>
        </div>
        <div className="btns">
        
            <div className="btn" onClick={()=>handleBtns("deleteProductWidgetState")}>
                {icons.delete}
                حذف منتج
            </div>
            <div className="btn"  onClick={()=>handleBtns("addProductWidgetState")}>
                {icons.add}
                إضافة منتج
            </div>
            <div className="btn" onClick={()=>handleBtns("editProductPriceWidgetState")}>
            {icons.edit}
               تعديل سعر منتج (فردي)
            </div>
            <div className="btn" onClick={()=>handleBtns("editCategoryPriceWidgetState")}>
            {icons.edit}
               تعديل سعر منتج (كمية)
            </div>
        </div>
        <div className="btns">
        
          <div className="btn" onClick={()=>navigate("/storage/report")}>
          <img width="32" height="32" src="https://img.icons8.com/405189/fluency-systems-filled/48/health-graph.png" alt="health-graph"/>
          تقرير مخزن</div>
        </div>
        <div className="table-parent">
        <table>
        <thead>
            <tr>
                <th>التسلسل</th>
                <th>الإسم</th>
                <th>الكود</th>
                <th>سعر الشراء</th>
                <th>سعر البيع</th>
                <th>الموكل</th>
                <th>الضمان</th>
                <th>الصنف</th>
                <th>التاريخ</th>
            </tr>
        </thead>
        <tbody>
            {products.map((ele,index)=>{
              ele = JSON.parse(ele);
                return <tr key={index}>
                    <td className="index">{index +1}</td>
                    <td>{ele.name}</td>
                    <td>{ele.serial}</td>
                    <td>{ele.price}</td>
                    <td>{ele.customerprice}</td>
                    <td>{ele.client}</td>
                    <td>{ele.gurantee}</td>
                    <td>{ele.category}</td>
                    <td>{ele.date}</td>
                    <div style={{"display": "flex"}}>
                    {controlBtns?<button className="del" onClick={()=>{
                      dispatch({ type: "", payload: { deleteproduct_code: ele.serial } });
                      handleBtns("deleteProductWidgetState");
                    }}>حذف</button>:null } 
                    {controlBtns?<button className="edit" onClick={()=>{
                      dispatch({ type: "", payload: { editproductprice_serial: ele.serial, editproductprice_name: ele.name, editproductprice_price: ele.price , editproductprice_customerprice: ele.customerprice , editproductprice_gurantee: ele.gurantee, editproductprice_client: ele.client , editproductprice_date: ele.date } });
                      handleBtns("editProductPriceWidgetState");
                    }}>تعديل</button>:null } 
                    </div>

  
                </tr>
            })}
        </tbody>
      </table>
        </div>


              {
                searchByCodeWidgetState && (
                  <>
                    <Overlay />
                    <SearchByCodePopUp />
                  </>
                )
              }
              {
                searchByNameWidgetState && (
                  <>
                    <Overlay />
                    <SearchByNamePopUp />
                  </>
                )}
                {
                deleteProductWidgetState && (
                  <>
                    <Overlay />
                    <DeleteProductPopUp />
                  </>
                )}
                {
                addProductWidgetState && (
                  <>
                    <Overlay />
                    <AddProductPopUp />
                  </>
                )}
                {
                editProductPriceWidgetState && (
                  <>
                    <Overlay />
                    <EditProductPricePopUp />
                  </>
                )}
                {
                editCategoryPriceWidgetState && (
                  <>
                    <Overlay />
                    <EditCategoryPricePopUp />
                  </>
                )}
    </div>
      {overlay ? <Overlay></Overlay> : null}
    </>
}

export default Storage;